import { MutableRecordStore } from '@deqo/foundation';
import { ApiClient } from '../../api/ApiClient';
import { v2 } from '../../api/ApiInterfaceV2';
import { AdminGeneralInfoData } from '../../api/endpoints/admin';
import { AppEvents } from '../AppEvents';
import { createScope } from '../Scope';
import { ModelBroker } from '../dashboard/Models';

const template: AdminGeneralInfoData = {
    subscription: false,
    users: {
        owners: 0,
        admins: 0,
        members: 0,
        guests: 0
    },
    workspaces: 0,
    boards: 0,
    objects: 0,
    stickys: 0,
};

export class ManageInformationModel extends MutableRecordStore(template) {

    public readonly id = '$';

    public static create(_broker: ModelBroker) {
        return new ManageInformationModel();
    }
}

// const onUserLeave = (broker: ModelBroker) => (e: AppEventStreams['account:userLeave']) => {
//     broker.get(ManageInformationModel).update(x => {
//         const i = x.findIndex(u => u.id === e.userId);
//         if (i >= 0) x.splice(i, 1);
//     });
// };

// const onSetRole = (broker: ModelBroker) => (e: AppEventStreams['account:setRole']) => {
//     broker.get(ManageInformationModel).update(x => {
//         Object.assign(x.find(u => u.id === e.userId), { roleName: e.roleName });
//     });
// };

export const ManageInformationScope = createScope({
    async refresh(p, c) {
        const api = c.get(ApiClient);
        const broker = c.get(ModelBroker);
        const evts = c.get(AppEvents);

        const data = await api.exec(v2.admin.general.info());
        const model = broker.allocate(ManageInformationModel);
        model.mutate(data);
        c.bind(ManageInformationModel).toConstantValue(model);

        return [
            // evts.on('account:userLeave', onUserLeave(broker)),
            // evts.on('account:setRole', onSetRole(broker)),
        ];
    }
});
